
import API from '@/api/api_sign'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

export default {
directives: {
TransferDom
},
components: {
Tabbar,
Scroller,Spinner,LoadMore,
Tab, TabItem,
TabbarItem,
Group,
Cell,
Card,
Popup,
XButton,
XInput
},
data () {
return {
list:[],
signTag:1,
password:'',
page:0,
total:0,
pageSize:15,
mobile:this.$store.state.userInfo.phoneNo,
show:false,
codeVal: '获取验证码',
codeFlog: false,
wait: 60,
loading:false,
listLoading:true,
contractId:'',
end:1,
}
},
created(){
this.getList();
window.addEventListener('scroll', this.onScrollg);
},
methods: {
go(obj){
if(obj.realNameStatus=='0'){
this.$router.push({path:`/checkbusiness/1`,query:{customerNo:obj.customerNo}});
}else{

}
},
onScrollg() {
var that = this;

let innerHeight = document.querySelector('#app').clientHeight;


let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop

let scrollHeight = document.documentElement.clientHeight || document.body.scrollHeight

if (innerHeight < (scrollHeight + scrollTop) + 1 && that.end != 0) {

that.getList();

}
},
handler(index){
if(index ==0){
this.signTag =1;
}else{
this.signTag =0;
}
this.list= [];
this.total = 0;
this.page =0;
this.getList();
},
getList(){
this.end = 0;
this.page++;
let pp ={
realNameTag:this.signTag,
pageNum:this.page,
pageSize:this.pageSize,
enablePaging:true
}
this.listLoading =true;
API.listall(pp).then((res)=>{
if (res.code == '000000') {
this.list = this.list.concat(res.data.list);
this.total =Number(res.data.total);
this.listLoading =false;
if(this.total==this.list.length){
this.end = 0;
}else{
this.end =1;
}
}else{
this.$vux.toast.show({
type:'cancel;',
text:res.msg
});
this.listLoading =false;
}
})
},

},
destroyed() {
var that = this;
window.removeEventListener('scroll', that.onScrollg)
}
}



// WEBPACK FOOTER //
// ./src/pages/entList.vue